// extracted by mini-css-extract-plugin
export default {"paneFooter":"paneFooter---OyMG9"};